import { useEffect, useState } from 'react';

/**
 * 断点判定。
 *
 * 只有两种场景需要它：
 *   1. 窄屏把「参数 / 结果」拆成两个页签；
 *   2. 编辑弹窗在窄屏改为底部抽屉。
 * 因此断点集合保持很小，避免出现「每个组件各有一套断点」的混乱。
 */
export const BREAKPOINTS = {
  /** 手机竖屏 */
  sm: 640,
  /** 平板竖屏 */
  md: 768,
  lg: 1024,
} as const;

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    listener();
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
}

/** 是否处于「窄屏」：参数与结果需要拆成页签 */
export function useIsNarrow(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.md - 1}px)`);
}

/** 是否处于「手机」：编辑表单改为底部抽屉、按钮加大到 44px */
export function useIsPhone(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.sm - 1}px)`);
}
